module.exports = __webpack_public_path__ + "img/logo.21c9b228.png";